var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirportTransferCarFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5L6 7.90909V12.2727C6 16.3091 8.77333 20.0836 12.5 21C16.2267 20.0836 19 16.3091 19 12.2727V7.90909L12.5 5ZM12.5 8.40364C12.8611 8.40364 13.1861 8.71636 13.1861 9.09455V11.6255L16.8333 13.9164V14.84L13.1861 13.6909V16.2145L14.0961 16.9055V17.5964L12.5 17.1309L10.9039 17.5964V16.9055L11.8139 16.2145V13.6909L8.16667 14.84V13.9164L11.8139 11.6255V9.09455C11.8139 8.71636 12.1389 8.40364 12.5 8.40364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirportTransferCarFilledIcon);
export default __webpack_public_path__ + "static/media/airport-transfer-car-filled-icon.b1a0ea32fd808ced482567a07c935a7b.svg";
export { ForwardRef as ReactComponent };